import { render } from "./ForgetPassView.vue?vue&type=template&id=5ea6e140&scoped=true"
import script from "./ForgetPassView.vue?vue&type=script&lang=js"
export * from "./ForgetPassView.vue?vue&type=script&lang=js"

import "./ForgetPassView.vue?vue&type=style&index=0&id=5ea6e140&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea6e140"]])

export default __exports__